<template>
    <div class="page-content">
        <kyaneos-header />
        <div class="inner-content">
            <div class="label main_color_text">
                Annexe
            </div>
        </div>
        <el-table :key="logements.key" :table="table_logements" lines-box-class="left toper" />
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import KyaneosHeader from "@/components/study/editor/elements/parts/kyaneos-header";

export default {
	components: { KyaneosHeader },
	name: "page-kyaneos-6",
	mixins: [PageMixin],
	data: () => ({
		logements: {
			valeur_metrique_globale: "",
			key: 0,
		},
		max_row_table: 21
	}),

	props: ["index","name"],
	computed: {
		...mapGetters(["active_study", "editor"]),
		show_annexes () {
			return this.editor.mode === "editing" || this.active_study.etudeData.scpi.evaluation.show_annexes_commentaire || this.active_study.etudeData.scpi.evaluation.show_annexes_garages || this.active_study.etudeData.scpi.evaluation.show_annexes_locaux_commerciaux || this.active_study.etudeData.scpi.evaluation.show_annexes_bureaux;
		},
		table_logements: function () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [9, 5, 8, 19, 12, 5, 15, 10, 10, 7],
				},
			};
			table.head.push([
				"Code",
				"Type",
				"Surf. hab.",
				"Type Bail",
				"Loyer",
				"Etat locatif",
				"Ratio locatif",
				"Abattement pour occupation",
				"Valeur métrique",
				"Valeur retenue"
			]);
			const tableNumber = parseInt(this.name.split("-")[this.name.split("-").length - 1]); // get which table it is

			const lots = this.active_study.etudeData.kyaneosData.Lots;

			// index of the first element of this table
			const beginningIndex = this.max_row_table * (tableNumber);
	
			// index of the first element of the next table
			const endingIndex = this.max_row_table * (tableNumber + 1);

			const calculs = [];

			lots.forEach((lot, i) => {
				const ratio = (lot.Loyer / lot.Surface).toFixed(2);
				const retenue = (lot.Surface * lot.valeur_metrique * (1 - lot.abattement_occupation / 100)).toFixed(2);
				calculs[i] = {
					ratio,
					retenue
				};
				if(i >= beginningIndex && i < endingIndex){
					table.body.push([
						{
							parent_data: lot,
							property: "Code",
							editable: true,
						},
						{
							parent_data: lot.TypeLogement,
							property: "Libelle",
							editable: true,
						},
						{
							parent_data: lot,
							property: "Surface",
							editable: true,
							suffix: "m²"
						},
						{
							parent_data: lot,
							property: "TypeBail",
							editable: true,
						},
						{
							parent_data: lot,
							property: "Loyer",
							editable: true,
							suffix: "€"
						},
						{
							parent_data: lot,
							property: "EtatLocatif",
							editable: true
						},
						{
							value: isNaN(ratio) || !isFinite(ratio) ? "-" : ratio,
							suffix: "€/m²"
						},
						{
							parent_data: lot,
							property: "abattement_occupation",
							editable: true,
							suffix: "%"
						},
						{
							parent_data: lot,
							property: "valeur_metrique",
							editable: true,
							suffix: "€/m²"
						},
						{
							value: isNaN(retenue) || !isFinite(retenue) ? "-" : retenue,
							editable: true,
							suffix: "€"
						},
					]);
				}
				
			});

			if((this.max_row_table * (tableNumber + 1)) >= (this.active_study.etudeData.kyaneosData.Lots.length)){
				table.body.push([
					{
						value: `TOTAL (${lots.length}   lgts)`,
						bg_color: "gray",
					},
					{
						value: " ",
						bg_color: "gray",
					},
					{
						value: " ",
						bg_color: "gray",
					},
					{
						value: " ",
						bg_color: "gray",
					},
					{
						value: " ",
						bg_color: "gray",
					},
					{
						value: " ",
						bg_color: "gray",
					},
					{
						value: " ",
						bg_color: "gray",
					},
					{
						value: " ",
						bg_color: "gray",
					},
					{
						value: " ",
						bg_color: "gray",
					},
					{
						value: lots.reduce((acc, lot, index) => acc + (+calculs[index].retenue || 0), 0).toFixed(2),
						suffix: "€",
						bg_color: "gray",
					},
				]);
			}
			return table;
		}
	}
};

</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'
@import '../../../../assets/css/kyaneos'
</style>